// extracted by mini-css-extract-plugin
export default {"hr-desktop":"CollapsibleForm-module__hr-desktop__vRGDD","hr-mobile":"CollapsibleForm-module__hr-mobile___R2An","subtitle":"CollapsibleForm-module__subtitle__oYw1F"};